import apiClient from '@/services/axios'

export function getTags() {
  return apiClient.get(`/tags`)
}

export function getTagById(id) {
  return apiClient.get(`/tags/${id}`)
}

export function createTag(tag) {
  return apiClient.post(`/tags`, tag)
}

export function updateTag(tag) {
  return apiClient.patch(`/tags/${tag.id}`, tag)
}

export function deleteTag(id) {
  return apiClient.delete(`/tags/${id}`)
}
